import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'widget-avatar',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="avatar" [style.width.px]="boyut()" [style.height.px]="boyut()" [style.background]="arkaplan()">
      @if (resimUrl()) {
        <img [src]="resimUrl()" [style.width.px]="boyut()" [style.height.px]="boyut()" alt="" />
      } @else {
        <span class="harf-metin" [style.font-size.px]="boyut() * 0.42">{{ gosterimHarf() }}</span>
      }
      @if (durumDot()) {
        <span class="durum-dot" [style.background]="durumRenk()"></span>
      }
    </div>
  `,
  styles: [`
    :host { display: inline-block; }
    .avatar {
      position: relative; border-radius: 50%; overflow: hidden;
      display: inline-flex; align-items: center; justify-content: center;
    }
    .avatar img { width: 100%; height: 100%; object-fit: cover; display: block; }
    .harf-metin { color: #fff; font-weight: 700; line-height: 1; user-select: none; }
    .durum-dot {
      position: absolute; bottom: 0; right: 0;
      width: 25%; height: 25%; min-width: 8px; min-height: 8px;
      border-radius: 50%; border: 2px solid var(--py-arkaplan, #fff);
    }
  `],
})
export class AvatarComponent {
  resimUrl = input('');
  harf = input('');
  renk = input('#1890ff');
  boyut = input(40);
  durumDot = input('');

  gosterimHarf = computed(() => (this.harf() || '?').charAt(0).toUpperCase());
  arkaplan = computed(() => this.resimUrl() ? 'transparent' : this.renk());

  durumRenk = computed(() => {
    const map: Record<string, string> = { online: '#52c41a', offline: '#bfbfbf', mesgul: '#f5222d', uzakta: '#faad14' };
    return map[this.durumDot()] || this.durumDot();
  });
}
